/**
 * Number of items the backend returns per page. We send `PAGE_SIZE + 1`
 * to peek whether one more page exists without an extra round-trip.
 */
export const PAGE_SIZE = 50;
export const PEEK_LIMIT = PAGE_SIZE + 1;

/** Smaller first page for children — the tree-view UI shows a small default count. */
export const CHILDREN_PAGE_SIZE = 10;
export const CHILDREN_PEEK_LIMIT = CHILDREN_PAGE_SIZE + 1;
